<template>

    <div :style="'display: ' + rootElementDisplay + ';'">

        <slot :start-login-process="startLoginProcess" :working="working">

            <button @click.prevent="startLoginProcess" class="btn w-full flex items-center justify-center border border-gray-700 bg-black text-white">
                <div>
                    <svg-icon v-show="working" url="fas/spinner" cursor="pointer" class="fa-spin w-5 h-5" />
                    <svg-icon v-show="!working" url="fab/apple" cursor="pointer" class="w-5 h-5" />
                </div>
                <span class="ml-2">{{ _('Sign_in_with_apple.button') }}</span>
            </button>

        </slot>

    </div>

</template>

<script>

    import { mapGetters } from 'vuex'
    import axios from 'axios'

    export default {

        props: {
            rootElementDisplay : {
                required: false,
                type: String,
                default: 'block'
            },

            preventRegistration: {
                required: false,
                type: Boolean,
                default: true
            }
        },

        data() {
            return {
                working: false,
                displayStyle: 'block'
            };
        },

        computed: {
            ...mapGetters('general', ['_', 'getPath']),
        },

        methods: {
            startLoginProcess() {
                this.working = true;

                axios({
                    method: 'get',
                    url: '/apple/get_authorization_url',
                    params: {
                        pr: this.preventRegistration ? 1 : 0
                    }
                }).then(({data}) => {
                    this.redirectBrowser(data.url);
                }).catch((error) => {
                    this.$emit('error', error);
                });
            },

            redirectBrowser(url) {
                setTimeout(() => this.working = false, 3000);

                window.location.href = url;
            }
        }
    }

</script>
